// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableWrapper":"_3eCNWV","lifeLinkPaymentPayoutTable":"u80EV8","infoBtn":"_2TG1BO"};